import navigation from './mainNav';
import inputText from './inputText';
import inputEmail from './inputEmail';
import inputTel from './inputTel';
import inputNumber from './inputNumber';
import inputRadio from './inputRadio';
import inputCheckbox from './inputCheckbox';
import inputCheckbox_v2 from './inputCheckbox_v2';
import inputTime from './inputTime';
import inputDate from './inputDate';
import inputIDPassport from './inputIDPassport';
import inputID from './inputID';
import inputPassword from './inputPassword';
import inputFile from './inputFile';
import textarea from './textarea';
import select from './select';
import select_v2 from './select_v2';
import selectRelationship from './selectRelationship';
import selectRelationship_v2 from './selectRelationship_v2';
import selectThead from './selectThead';
import toggle from './toggle';
import toggle_v2 from './toggle_v2';
import toggleLarge from './toggleLarge';
import statusTag from './statusTag';
import modal from './modal';
import loader from './loader';
import toast from './toast';
import toast_v2 from './toast_v2';
import changePasswordBox from './changePasswordBox';
import progressSteps from './progressSteps';
import displayText from './displayText';
import sideNav from './sideNav';
import errorBox from './errorBox';
import dataListDropdown from './dataListDropdown';
import paginationButtons from './paginationButtons';
import table from './table';

export default {
  navigation,
  inputText,
  inputEmail,
  inputTel,
  inputNumber,
  inputRadio,
  inputCheckbox,
  inputCheckbox_v2,
  inputTime,
  inputDate,
  inputIDPassport,
  inputID,
  inputPassword,
  inputFile,
  textarea,
  select,
  select_v2,
  selectRelationship,
  selectRelationship_v2,
  selectThead,
  toggle,
  toggle_v2,
  toggleLarge,
  statusTag,
  modal,
  loader,
  toast,
  toast_v2,
  changePasswordBox,
  progressSteps,
  displayText,
  sideNav,
  errorBox,
  dataListDropdown,
  paginationButtons,
  table,
};
